import moment from 'moment';
import API from '../utils/API';
import { toastError } from '../utils/toastMessage';
import * as actionTypes from '../constants/constants';

export function setBasketData({ basketId, products }) {
  return {
    type: actionTypes.SET_BASKET_DATA,
    payload: {
      basketId,
      products,
    },
  };
}

export function hideBasket() {
  return {
    type: actionTypes.HIDE_BASKET,
  };
}

export function showBasket() {
  return {
    type: actionTypes.SHOW_BASKET,
  };
}

export function setIsLoadingBasketData(isLoadingBasketData) {
  return {
    type: actionTypes.SET_IS_LOADING_BASKET_DATA,
    payload: {
      isLoadingBasketData,
    },
  };
}
export function setBasketDatesRange({ startDate, endDate }) {
  return {
    type: actionTypes.SET_BASKET_DATES_RANGE,
    payload: {
      startDate,
      endDate,
    },
  };
}

export function getBasketData(complexId, startDate) {
  const endDate = moment(startDate).add(6, 'days').format('YYYY-MM-DD');

  return (dispatch) => {
    dispatch(setIsLoadingBasketData(true));
    API.get(`/basket/${complexId}?start_date=${startDate}&end_date=${endDate}`)
      .then((response) => {
        const { content, basket_id, start_date, end_date } = response.data.data;
        const sortedProducts = content.sort((prevProd, newProd) => {
          if (prevProd.status && newProd.staus) return 0;
          if (prevProd.status && !newProd.staus) return 1;
          return -1;
        });
        dispatch(
          setBasketData({
            basketId: basket_id,
            products: sortedProducts,
          }),
        );
        dispatch(
          setBasketDatesRange({
            startDate: start_date,
            endDate: end_date,
          }),
        );
      })
      .catch(function () {
        toastError('Корзина не найдена');
        dispatch(hideBasket());
        dispatch(setIsLoadingBasketData(false));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/basket.js